export async function getCurrentPosition(
  options?: PositionOptions,
  askForPermission = true
): Promise<GeolocationPosition> {
  const permission = await navigator.permissions.query({ name: 'geolocation' })
  if (!askForPermission && permission.state !== 'granted') {
    throw new Error('Permission denied')
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })
}
